import React, { useState, lazy, Suspense } from "react";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";
import NavbarComponent from "./Navbar";
import styled, { createGlobalStyle } from "styled-components";

import { Helmet } from "react-helmet";

import logo from "./assets/images/logo.png";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap');

  body {
    font-family: 'Poppins', sans-serif;
    background: #eee;
  }
`;
const FooterInsert = lazy(() => import("./FooterInsert"));

const StyledLink = styled(Link)`
  position: relative;
  color: black;
  margin-right: 50px;
  text-decoration: none;
  font-size: 18px;

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -10px;
    left: 0;
    background-color: transparent;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
  }

  &:hover::before,
  &:focus::before {
    visibility: visible;
    width: 100%;
    background-color: transparent;
  }
`;

const Logo = styled.img`
  height: 200px;
  width: auto;
  border: none;
  outline: none;
  text-decoration: none !important;
  z-index: 1;
`;

const PayPCNContainer = styled(Container)`
  margin-top: 70px;
  margin-bottom: 40px; 
`;

const StyledCol = styled(Col)`

  background-color: #fff;
  padding: 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    padding: 80px;
  }
`;

const StyledForm = styled(Form)`
    width: 100%;

    @media (min-width: 998px) {
        width: 572px;
    }
    text-align: left;
  .form-control {
    width: 100%;
    height: 56px;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: all 0.3s ease-in-out;
    font-size: 14px;

    &:hover,
    &:focus {
      border-color: #dfd40a; // Adding hover/focus effect to form fields
    }
  }

  .form-control[type="textarea"] {
    height: 150px;
  }
  .form-label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;

const StyledButton = styled(Button)`
  background-color: #F3E800;
  border-color: #F3E800;
  color: #292929;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  width: 100%;
  transition: background-color 0.3s ease, border-color 0.3s ease;

  &:hover,
  &:focus {
    background-color:#dfd40a;
    border-color:#dfd40a;
    color: #292929;
  }
`;

const StyledHeading = styled.h2`
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 16px;
`;

const StyledParagraph = styled.p`
  font-size: 14px;
  color: #85858A;
  margin-bottom: 0;
`;
const StyledTitleContent = styled.div`
  padding-bottom: 32px;
  @media (min-width: 768px) {
    padding-left: 32px;
    padding-right: 32px;
  }
`;

const PayPCN = () => {
  const [referenceNumber, setReferenceNumber] = useState("");
 
    const handleSubmit = (event) => {
        event.preventDefault();

        if (referenceNumber.length < 13) {
            window.open(`https://retailpark.ec6pay.com?ref=${referenceNumber}`, "_blank");
        } else {
            window.open(`https://paycharge.retailparkuk.co.uk?ref=${referenceNumber}`, "_blank");
        }
    };


  return (
    <div>
      <Helmet>
        <meta
          name="description"
          content="Welcome to Retail Park Payment"
        />
      </Helmet>
      <GlobalStyle />
      <NavbarComponent />
      <Container>
        <Row>
          <Col>
            <StyledLink
              to="/"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <Logo src={logo} alt="Logo" />
            </StyledLink>
          </Col>
        </Row>
      </Container>

      <PayPCNContainer>
        <Container>
          <Row>
            <StyledCol md={{ span: 9, offset: 2 }}>
                <StyledTitleContent>
                    <StyledHeading>Welcome to Retail Park Payments</StyledHeading>
                    <p>In order to direct you to the appropriate payment page, please enter the reference number associated with your PCN below.</p>
                    <StyledParagraph>(You may need to re-enter it after redirection)</StyledParagraph>
                </StyledTitleContent>
              <StyledForm onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label>Reference Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={referenceNumber}
                    onChange={(e) => setReferenceNumber(e.target.value)}
                    required
                    placeholder="Enter your Reference Number"
                  />
                </Form.Group>
                <StyledButton variant="primary" type="submit">
                  Submit
                </StyledButton>
              </StyledForm>
            </StyledCol>
          </Row>
        </Container>
      </PayPCNContainer>

      <Suspense fallback={<div>Loading...</div>}>
        <FooterInsert />
      </Suspense>
    </div>
  );
};

export default PayPCN;
